import { addHeaderInterceptor as a } from "./add-header-interceptor-factory.js";
import { getToken as n } from "@accor/customer-api/cloud";
import { envManager as c } from "../../envManager.js";
const i = async () => {
  var r, t;
  try {
    const { token: e } = await n();
    return e;
  } catch (e) {
    const o = (t = (r = c) == null ? void 0 : r.appConfig) == null ? void 0 : t.getTokenErrorHandler;
    if (o)
      return await o(e);
    throw e;
  }
}, f = (r) => r.interceptors.request.use(
  a("Authorization", async () => `Bearer ${await i()}`)
);
export {
  f as default,
  i as getJWT
};
//# sourceMappingURL=bearer-token-interceptor.js.map
